"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingRoomForm = void 0;
const lodash_1 = __importDefault(require("lodash"));
require("angular-ui-bootstrap");
const meetingRoom_service_1 = require("ucassistant/services/meetingRoom.service");
class AjaxRequest {
    constructor(ongoing = false, error) {
        this.ongoing = ongoing;
        this.error = error;
    }
}
class ErrorResponse {
    constructor(error) {
        this.error = error;
    }
}
class PersonalMeetingRoom extends meetingRoom_service_1.MeetingRoom {
    constructor(id, displayName, userPin, number, uuid) {
        super(id, displayName, userPin, number, uuid);
        this.id = id;
        this.displayName = displayName;
        this.userPin = userPin;
        this.number = number;
        this.uuid = uuid;
        this.roomType = "personal";
    }
}
class MeetingRoomForm {
    constructor(displayName = "", userPin) {
        this.displayName = displayName;
        this.userPin = userPin;
    }
}
exports.MeetingRoomForm = MeetingRoomForm;
class MeetingRoomController {
    constructor($scope, $window, $state, $uibModal, $uibModalStack, $log, MeetingRoomService, XucDirectory, roomId) {
        this.$scope = $scope;
        this.$window = $window;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$uibModalStack = $uibModalStack;
        this.$log = $log;
        this.MeetingRoomService = MeetingRoomService;
        this.XucDirectory = XucDirectory;
        this.roomId = roomId;
        this.favorite = false;
        this.numberPattern = /^[0-9]+$/;
        this.ajaxRequest = new AjaxRequest();
        if (this.roomId) {
            this.MeetingRoomService.get(this.roomId).then((response) => {
                this.currentMeetingroom = response.data;
                this.populateForm(response);
            });
        }
        this.form = new MeetingRoomForm();
    }
    populateForm(resp) {
        this.favorite = this.isFavorite();
        this.form.displayName = resp.data.displayName;
        this.form.userPin = resp.data.userPin;
    }
    isFavorite() {
        return lodash_1.default.some(this.XucDirectory.getFavoriteContactSheet(), (c) => {
            return c.sources[0].id === this.roomId;
        });
    }
    isValidForm() {
        return !(lodash_1.default.isEmpty(this.form.displayName));
    }
    saveForm() {
        var _a;
        let mr = new PersonalMeetingRoom(parseInt(this.roomId) || undefined, this.form.displayName, this.form.userPin != "" ? this.form.userPin : undefined, (_a = this.currentMeetingroom) === null || _a === void 0 ? void 0 : _a.number);
        this.save(mr).catch(this.catchMeetingRoomError.bind(this));
    }
    save(meetingroom) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.ajaxRequest.ongoing = true;
            try {
                const meetingRoomResponse = this.roomId
                    ? yield this.MeetingRoomService.update(meetingroom)
                    : yield this.MeetingRoomService.add(meetingroom);
                if (this.favorite && !this.isFavorite()) {
                    this.$window.Cti.addFavorite((_a = meetingRoomResponse.data.id) === null || _a === void 0 ? void 0 : _a.toString(), "xivo_meetingroom");
                }
                if (!this.favorite && this.isFavorite()) {
                    this.$window.Cti.removeFavorite((_b = meetingRoomResponse.data.id) === null || _b === void 0 ? void 0 : _b.toString(), "xivo_meetingroom");
                }
                this.close("interface.favorites");
            }
            finally {
                this.ajaxRequest.ongoing = false;
            }
        });
    }
    catchMeetingRoomError(error) {
        this.$log.error(error.data);
        this.ajaxRequest.error = "error" + error.data.error;
    }
    remove() {
        this.MeetingRoomService.remove(this.roomId).then(() => {
            this.close("interface.favorites");
        });
    }
    close(dest) {
        this.$state.go(dest);
        this.$uibModalStack.dismissAll();
    }
    dismiss() {
        this.roomId
            ? this.close("interface.favorites")
            : this.close("interface.menu");
    }
    confirmDelete() {
        this.$uibModal.open({
            templateUrl: "confirmDialog.html",
            size: "sm",
            scope: this.$scope,
            controller: "ConfirmationModalController",
            controllerAs: "modalCtrl",
            resolve: {
                params: () => {
                    return { item: "MEETING_ROOM" };
                },
            },
        });
    }
}
exports.default = MeetingRoomController;
